// extracted by mini-css-extract-plugin
export default {"textSection":"BlueTextSection_textSection__2xwp4","phoneNumber":"BlueTextSection_phoneNumber__KXw3G"};